import { Button, Modal } from 'antd';
import React, { useEffect, useState } from "react";
import {
  TransactionPdfData,
  TransactionsGeneratePdf,
} from "../pdf/transactions-pdf";
import { pdf } from "@react-pdf/renderer";
import { IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction, Maybe } from "../../../../generated";
import { PDFViewer } from "../../../shared/pdf-viewer";

interface SendRefundFormProps {
  amount: number;
  reason: string;
  isAdmin: boolean;
  transactions: any;
  id: string;
}

export const SendRefundForm: React.FC<SendRefundFormProps> = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction | undefined>(undefined);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);

  useEffect(() => {
    const generatePdf = async () => {
      if (selectedTransaction) {
        const transactionData: TransactionPdfData = {
          tableData: selectedTransaction,
          amountLabel: "Refund Amount:",
        };
        try {
          // Generate the PDF asynchronously and set the blob state
          const blob = await pdf(<TransactionsGeneratePdf data={transactionData} />).toBlob();
          console.log('Generated PDF Blob:', blob);
          setPdfBlob(blob);
        } catch (error) {
          console.error('Error generating PDF:', error);
        }
      }
    };

    generatePdf();
  }, [selectedTransaction]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedTransaction(undefined);
    setPdfBlob(null);
  };

  const showModal = (transaction: IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction) => {
    const filterData = props.transactions.adhocTransactions.find(
      (item: { amount: Maybe<number> | undefined; reason: Maybe<string> | undefined }) =>
        Math.abs(item.amount || 0) === transaction.amount && item.reason === transaction.reason
    );
    setSelectedTransaction(filterData);
    setIsModalVisible(true);
  };

  const message = props.isAdmin ? `US$${props.amount} Sent Successfully for ${props.reason}` : `US$${props.amount} Refunded Successfully`;

  return (
    <div className="flex flex-col md:flex-row items-center md:items-start w-full rounded-lg overflow-auto bg-neutral-50	mt-2 shadow-sm">
      <div className="w-full bg-[#dbffc5] text-black text-wrap rounded-lg h-[100%] ">
        <p className="h-full overflow-auto m-4">{message}</p>
      </div>
        <div className="flex items-center justify-center h-[100%]">
          <Button className="m-2" onClick={() => showModal(props)}>
            View Receipt
          </Button>
      </div>

      {isModalVisible && (
        <Modal
          title={`Staff - ${selectedTransaction?.transactionReference?.referenceId}.pdf`}
          width="fit-content"
          open={isModalVisible}
          closable
          footer={[
            <Button key="close" onClick={handleCancel}>
              Close
            </Button>
          ]}
          onCancel={handleCancel}
          destroyOnClose
        >
          {pdfBlob ? (
            <PDFViewer filename={`Staff - ${selectedTransaction?.transactionReference?.referenceId}.pdf`} docId="" blobPromise={Promise.resolve(pdfBlob)}></PDFViewer>
          ) : (
            <p>Loading PDF...</p>
          )}
        </Modal>
      )}
    </div>
  );
};
